<script lang="ts">
  import { AppState } from '../../../etc/stores';
  import { _ } from 'svelte-i18n';
  import { pluralizeI18n } from '../../../etc/utils';
  import { replaceVariables } from '../../../i18n';

  const t = (text: string) => {
    return replaceVariables($_(`messages.${text}`), {
      COIN: $AppState.website.coins
    });
  };
</script>

<p>{t(pluralizeI18n('credit_card_coins', $AppState.website.coins))}</p>

<style lang="scss">
  @use './styles.scss' as *;
</style>
